import { render, staticRenderFns } from "./PreferencesComponent.vue?vue&type=template&id=17dff09c"
import script from "./PreferencesComponent.vue?vue&type=script&lang=js"
export * from "./PreferencesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports